import React from 'react';
import { PageHero } from '../components/PageHero';
import { AISecurityValidation } from '../components/AISecurityValidation';
import { AttackPathExamples } from '../components/AttackPathExamples';
import { Verification } from '../components/Verification';
import { SectionStage } from '../components/SectionStage';
export function AISecurity() {
  return <>
      <PageHero eyebrow="AI Security Validation" title="Secure the AI apps" titleMuted="you build." description="LLM apps, agents, and copilots are creating risk faster than security teams can review. Periscan validates the AI applications you build like adversaries — and proves they're safe to ship." bg="none" data-id="element-1464" />
      <SectionStage fx="matrix-aurora" data-id="element-1465">
        <AISecurityValidation data-id="element-1466" />
      </SectionStage>
      <SectionStage fx="threads" data-id="element-1467">
        <AttackPathExamples data-id="element-1468" />
      </SectionStage>
      <SectionStage fx="ripple" data-id="element-1469">
        <Verification data-id="element-1470" />
      </SectionStage>
    </>;
}